import type { MermaidEdge, MermaidNode } from "../utils"

import { parseMermaidCode } from "../utils"

const MAX_HISTORY_SIZE = 50

export type HistoryEntry = {
  nodes: MermaidNode[]
  edges: MermaidEdge[]
  code: string
}

export type SaveToHistoryInput = { nodes: MermaidNode[]; edges: MermaidEdge[]; code: string }

export type MermaidEditorStateBase = {
  history: HistoryEntry[]
  historyIndex: number
  isDirty: boolean
}

const DEFAULT_CODE = `flowchart TD
    A[Start] --> B{Decision}
    B -->|Yes| C[Action 1]
    B -->|No| D[Action 2]
    C --> E[End]
    D --> E`

export function createInitialState() {
  const parsed = parseMermaidCode(DEFAULT_CODE)
  return {
    diagramId: null,
    title: "Untitled Diagram",
    direction: parsed.direction,
    nodes: parsed.nodes,
    edges: parsed.edges,
    code: DEFAULT_CODE,
    subgraphs: parsed.subgraphs,
    history: [{ nodes: parsed.nodes, edges: parsed.edges, code: DEFAULT_CODE }] as HistoryEntry[],
    historyIndex: 0,
    isDirty: false,
    isValid: true,
    parseError: null,
    syncSource: null,
    selectedNodeIds: [] as string[],
  }
}

export function saveToHistory(
  state: MermaidEditorStateBase,
  input: SaveToHistoryInput
): Partial<MermaidEditorStateBase> {
  const currentEntry: HistoryEntry = {
    nodes: structuredClone(input.nodes),
    edges: structuredClone(input.edges),
    code: input.code,
  }

  const newHistory = state.history.slice(0, state.historyIndex + 1)
  newHistory.push(currentEntry)

  if (newHistory.length > MAX_HISTORY_SIZE) {
    newHistory.shift()
  }

  return {
    history: newHistory,
    historyIndex: newHistory.length - 1,
    isDirty: true,
  }
}
